import { Theme } from '@mui/material/styles';
import styled from 'styled-components';

const FormContainer = styled.form<{ theme: Theme }>`
  display: flex;
  flex-direction: column;

  > * {
    margin-bottom: ${({ theme }) => theme.spacing(2.5)};
  }

  a {
    padding: ${({ theme }) => theme.spacing(1.5)};
  }

  form {
    display: flex;
    flex-direction: column;

    > * {
      margin-bottom: ${({ theme }) => theme.spacing(2.5)};
    }
  }
`;

const ErrorMessage = styled.p<{ theme: Theme }>`
  color: ${({ theme }) => theme.palette.error.main};
  margin-top: 0;
`;

export { FormContainer, ErrorMessage };
